import Swiper from 'swiper';
import { Pagination, Autoplay, Navigation, Thumbs } from 'swiper/modules';

// =======================
// SWIPER CUSTOM HOME
// =======================
var swiperSolutionAcq = null;
var swiperSolutionVend = null;

function initSwiperAcq() {
    if (!swiperSolutionAcq) {
        swiperSolutionAcq = new Swiper("#swiperSolutionAcq", {
            modules: [Pagination, Autoplay],
            slidesPerView: 1,
            spaceBetween: 0,
            //autoHeight: true,
            virtual: { enabled: true },
            pagination: {
                el: "#swiperPagination-perchiacquista",
                clickable: true
            },
            breakpoints: {
                768: {
                    slidesPerView: 1.5,
                    spaceBetween: 16
                },
                992: {
                    slidesPerView: 1.75,
                    spaceBetween: 16
                },
                1200: {
                    slidesPerView: 2.25,
                    spaceBetween: 16
                },
                1400: {
                    slidesPerView: 3,
                    spaceBetween: 16
                }
            }
        });
    } else {
        swiperSolutionAcq.update();
        swiperSolutionAcq.updateAutoHeight && swiperSolutionAcq.updateAutoHeight();
    }
}

setTimeout(function () {
    initSwiperAcq();
}, 300);

function initSwiperVend() {
    if (!swiperSolutionVend) {
        new Swiper("#swiperSolutionVend", {
            modules: [Pagination, Autoplay],
            slidesPerView: 1.25,
            spaceBetween: 16,
            //autoHeight: true,
            virtual: { enabled: true },
            pagination: {
                el: "#swiperPagination-perchivende",
                clickable: true
            },
            breakpoints: {
                768: {
                    slidesPerView: 1.5,
                    spaceBetween: 16
                },
                992: {
                    slidesPerView: 1.75,
                    spaceBetween: 16
                },
                1200: {
                    slidesPerView: 2.25,
                    spaceBetween: 16
                }
            }
        });
    } else {
        swiperSolutionVend.update();
        swiperSolutionVend.updateAutoHeight && swiperSolutionVend.updateAutoHeight();
    }
}

// Inizializza Swiper per la tab attiva all'avvio
document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector('#swiperSolutionAcq') && document.querySelector('#swiperSolutionAcq').offsetParent !== null) {
        initSwiperAcq();
    }
    if (document.querySelector('#swiperSolutionVend') && document.querySelector('#swiperSolutionVend').offsetParent !== null) {
        initSwiperVend();
    }

    // Aggiorna Swiper al cambio tab
    document.querySelectorAll('[data-bs-toggle="tab"]').forEach(function (tab) {
        tab.addEventListener('shown.bs.tab', function (e) {
            setTimeout(function () {
                if (document.querySelector('#swiperSolutionAcq') && document.querySelector('#swiperSolutionAcq').offsetParent !== null) {
                    initSwiperAcq();
                }
                if (document.querySelector('#swiperSolutionVend') && document.querySelector('#swiperSolutionVend').offsetParent !== null) {
                    initSwiperVend();
                }
            }, 50);
        });
    });

    // Aggiorna/inizializza Swiper su resize
    window.addEventListener('resize', function () {
        // Swiper Acq
        if (document.querySelector('#swiperSolutionAcq') && document.querySelector('#swiperSolutionAcq').offsetParent !== null) {
            if (!swiperSolutionAcq) {
                initSwiperAcq();
            } else {
                swiperSolutionAcq.update();
                swiperSolutionAcq.updateAutoHeight && swiperSolutionAcq.updateAutoHeight();
            }
        }
        // Swiper Vend
        if (document.querySelector('#swiperSolutionVend') && document.querySelector('#swiperSolutionVend').offsetParent !== null) {
            if (!swiperSolutionVend) {
                initSwiperVend();
            } else {
                swiperSolutionVend.update();
                swiperSolutionVend.updateAutoHeight && swiperSolutionVend.updateAutoHeight();
            }
        }
    });
});



// Swiper Punti Forza
var swiperPuntiForza = null;

function initSwiperPuntiForza() {
    var el = document.querySelector('#swiperPuntiForza');
    if (el && el.offsetParent !== null) {
        if (!swiperPuntiForza) {
            swiperPuntiForza = new Swiper("#swiperPuntiForza", {
                modules: [Pagination, Autoplay],
                slidesPerView: 1.25,
                spaceBetween: 8,
                autoHeight: true,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true
                },
                autoplay: {
                    delay: 3000,
                },
                breakpoints: {
                    576: { slidesPerView: 1, spaceBetween: 8 },
                    768: { slidesPerView: 1.5, spaceBetween: 8 },
                    992: { slidesPerView: 2, spaceBetween: 8 },
                    1200: { slidesPerView: 3, spaceBetween: 8 },
                    1400: { slidesPerView: 4, spaceBetween: 8 },
                }
            });
        } else {
            swiperPuntiForza.update();
            swiperPuntiForza.updateAutoHeight && swiperPuntiForza.updateAutoHeight();
        }
    }
}

document.addEventListener('DOMContentLoaded', function () {
    initSwiperPuntiForza();
    window.addEventListener('resize', function () {
        if (swiperPuntiForza) {
            swiperPuntiForza.update();
            swiperPuntiForza.updateAutoHeight && swiperPuntiForza.updateAutoHeight();
        }
    });
});


new Swiper("#swiperTeam", {
    modules: [Pagination, Autoplay],
    slidesPerView: 1.25,
    spaceBetween: 16,
    breakpoints: {
        768: {
            slidesPerView: 1.5,
            spaceBetween: 16,
        },
        992: {
            slidesPerView: 1.75,
            spaceBetween: 32,
        },
        1200: {
            slidesPerView: 2.15,
            spaceBetween: 32,
        },
        1400: {
            slidesPerView: 2.25,
            spaceBetween: 32,
        },
        1920: {
            slidesPerView: 2.75,
            spaceBetween: 32,
        }
    }
});

// =======================
// SWIPER CUSTOM LE NOSTRE COMPETENZE
// =======================


new Swiper("#swiperCompetenze", {
    modules: [Pagination, Autoplay],
    slidesPerView: 1.25,
    spaceBetween: 16,
    autoplay: {
        delay: 3000,
    },
    breakpoints: {
        576: {
            slidesPerView: 2.25,
            spaceBetween: 16,
        },
        768: {
            slidesPerView: 2.5,
            spaceBetween: 16,
        },
        992: {
            slidesPerView: 3.5,
            spaceBetween: 32,
        },
        1200: {
            slidesPerView: 4,
            spaceBetween: 32,
        },
    }
});

//swiperCompetenze01
var swiperCompetenze01 = null;

function initswiperCompetenze01() {
    if (!swiperCompetenze01) {
        swiperCompetenze01 = new Swiper("#swiperCompetenze01", {
            slidesPerView: 1,
            spaceBetween: 0,
            virtual: { enabled: true },
            breakpoints: {
                992: {
                    slidesPerView: 2,
                    spaceBetween: 64,
                },
                1200: {
                    slidesPerView: 3,
                    spaceBetween: 64,
                }
            }
        });
    } else {
        swiperCompetenze01.update();
        swiperCompetenze01.updateAutoHeight && swiperCompetenze01.updateAutoHeight();
    }
}

// Inizializza Swiper per la tab attiva all'avvio
document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector('#swiperCompetenze01') && document.querySelector('#swiperCompetenze01').offsetParent !== null) {
        initswiperCompetenze01();
    }
    // Aggiorna Swiper su resize
    window.addEventListener('resize', function () {
        if (swiperCompetenze01) {
            swiperCompetenze01.update();
            swiperCompetenze01.updateAutoHeight && swiperCompetenze01.updateAutoHeight();
        }
    });
});





// =======================
// SWIPER CUSTOM HELP CENTER
// =======================
var swiperHelpCenter = null;

function initSwiperHelpCenter() {
    var el = document.querySelector('#swiperHelpCenter');
    if (el && el.offsetParent !== null) {
        if (!swiperHelpCenter) {
            swiperHelpCenter = new Swiper("#swiperHelpCenter", {
                modules: [Pagination, Autoplay],
                slidesPerView: 1.25,
                autoHeight: true,
                spaceBetween: 1,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                breakpoints: {
                    768: { slidesPerView: 1.5, spaceBetween: 1 },
                    992: { slidesPerView: 1.75, spaceBetween: 24 },
                    1200: { slidesPerView: 2.25, spaceBetween: 24 },
                    1400: { slidesPerView: 2.75, spaceBetween: 24 }
                }
            });
        } else {
            swiperHelpCenter.update();
            swiperHelpCenter.updateAutoHeight && swiperHelpCenter.updateAutoHeight();
        }
    }
}

document.addEventListener('DOMContentLoaded', function () {
    initSwiperHelpCenter();
    window.addEventListener('resize', function () {
        if (swiperHelpCenter) {
            swiperHelpCenter.update();
            swiperHelpCenter.updateAutoHeight && swiperHelpCenter.updateAutoHeight();
        }
    });
});



new Swiper("#swiperSoggetto", {
    modules: [Pagination, Autoplay],
    slidesPerView: 1,
    spaceBetween: 0,
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    breakpoints: {
        380: {
            slidesPerView: 1.25,
            spaceBetween: 16,
        },
        576: {
            slidesPerView: 2,
            spaceBetween: 16,
        },
        768: {
            slidesPerView: 2.25,
            spaceBetween: 32,
        },
        992: {
            slidesPerView: 3,
            spaceBetween: 32,
        },
        1200: {
            slidesPerView: 4,
            spaceBetween: 32,
        }
    }
});


// =======================
// SWIPER BLOGE
// =======================

new Swiper("#swiperBlog", {
    modules: [Pagination, Autoplay, Navigation],
    slidesPerView: 1,
    spaceBetween: 16,
    autoplay: {
        delay: 3000,
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
});

// =======================
// SWIPER GALLERY SCHEDA
// =======================
var swiperGalleryThumbs = null;
var swiperGalleryMain = null;

function initSwiperGallery() {
    var elThumbs = document.querySelector('#swiperGalleryThumbs');
    var elMain = document.querySelector('#swiperGalleryMain');

    if (elThumbs && elMain && elThumbs.offsetParent !== null) {
        if (!swiperGalleryThumbs) {
            // Inizializza swiper thumbnails
            swiperGalleryThumbs = new Swiper("#swiperGalleryThumbs", {
                modules: [Navigation, Thumbs],
                spaceBetween: 8,
                slidesPerView: 3,
                freeMode: true,
                watchSlidesProgress: true,
                breakpoints: {
                    576: {
                        slidesPerView: 4,
                        spaceBetween: 8,
                    },
                    768: {
                        slidesPerView: 4,
                        spaceBetween: 8,
                    },
                    992: {
                        slidesPerView: 4,
                        spaceBetween: 8,
                    },
                    1200: {
                        slidesPerView: 5,
                        spaceBetween: 8,
                    }
                }
            });

            // Inizializza swiper principale
            swiperGalleryMain = new Swiper("#swiperGalleryMain", {
                modules: [Navigation, Thumbs],
                spaceBetween: 10,
                navigation: {
                    nextEl: "#swiperGalleryMain .swiper-button-next",
                    prevEl: "#swiperGalleryMain .swiper-button-prev",
                },
                thumbs: {
                    swiper: swiperGalleryThumbs,
                },
            });
        } else {
            swiperGalleryThumbs.update();
            swiperGalleryMain.update();
        }
    }
}

document.addEventListener('DOMContentLoaded', function () {
    initSwiperGallery();

    window.addEventListener('resize', function () {
        if (swiperGalleryThumbs && swiperGalleryMain) {
            swiperGalleryThumbs.update();
            swiperGalleryMain.update();
        }
    });
});
